import type { Locale, SiteContext } from "./site";
import { localizeUrl, locales as allLocales, sites } from "./site";

export type SeoAlternate = { locale: Locale | "x-default"; href: string };

export function absoluteLocalizedUrl(pathname: string, locale: Locale): string {
  return new URL(localizeUrl(pathname, locale, sites.en.origin), sites.en.origin).href;
}

export function seoLinks(
  pathname: string,
  current: SiteContext,
  locales: Locale[] = [...allLocales],
) {
  const canonical = new URL(localizeUrl(pathname, current.locale, current.origin), current.origin)
    .href;
  const alternates: SeoAlternate[] = locales.map((locale) => ({
    locale,
    href: absoluteLocalizedUrl(pathname, locale),
  }));
  alternates.push({ locale: "x-default", href: absoluteLocalizedUrl(pathname, "en") });

  return [
    { rel: "canonical", href: canonical },
    ...alternates.map(({ locale, href }) => ({ rel: "alternate", hrefLang: locale, href })),
  ];
}

export function escapeXml(value: string): string {
  return value.replace(/[<>&'"]/g, (char) => {
    const entities: Record<string, string> = {
      "<": "&lt;",
      ">": "&gt;",
      "&": "&amp;",
      "'": "&apos;",
      '"': "&quot;",
    };
    return entities[char];
  });
}
